import { RepCardActions } from '../enums/card-actions.enum';
import { AccordionItem } from '../models/accordion-item.model';

export function actionHandler(
    data: AccordionItem[],
    actionType: RepCardActions,
    index: number,
): AccordionItem[] {
    const cardData = data;

    switch (actionType) {
        case RepCardActions.ACCORDION_TOGGLE: {
            cardData[index].isOpened = !(cardData[index].isOpened ?? false);
            break;
        }
        case RepCardActions.EXPAND_TABLE_TOGGLE: {
            cardData[index].isTableExpanded = !(
                cardData[index].isTableExpanded ?? false
            );
            break;
        }
        case RepCardActions.SHOW_MORE_TOGGLE: {
            cardData[index].isShowMoreEnabled = !(
                cardData[index].isShowMoreEnabled ?? false
            );
            break;
        }
    }

    return cardData;
}
